import type { TFunction } from "i18next";
import { z } from "zod";

export const passwordSchema = (t: TFunction) =>
    z
        .string()
        .min(8, t("signUp.field.error.smallPassword"))
        .max(100, t("signUp.field.error.bigPassword"))
        .refine((value) => {
            const regexChecks = [/[a-z]/, /[A-Z]/, /\d/, /[^\w\d\s]/];
            const matchCount = regexChecks.reduce((count, regex) => (regex.test(value) ? count + 1 : count), 0);
            return matchCount >= 3;
        }, t("signUp.field.error.weakPassword"));
